import api from '@/services/utils/base';
import store from '@/store';
import { StatusEnum } from '@/services/models/Enums';

export default class Integrations {
  get() {
    return api
      .get('/user/integrations')
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
    });
  }

  post(data:{name: string,type?: string,accessToken?: string}) {
    return api
      .post('/user/integrations',data)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      });
  }

  put(data:{name: string,type?: string,accessToken?: string,id?: string}) {
    return api
      .put(`/user/integrations/${data.id}`,data)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      });
  }

  delete(id: string) {
    return api.delete(`/user/integrations/${id}`)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      });
  }

  checkStatus(id: string) {
    return api.get(`/user/integrations/${id}/check-status`)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      });
  }

  populateStoreCache() {
    store.commit('cacheStartUpdating', 'campaigns');
    return api.get('/user/integrations').then((res)=>{
      store.commit('populateIntegrationsCache', res.data.payload);
      return Promise.resolve(res.data.payload);
    })
  }
} 
